import React from 'react'
import styles from './QuestionContainer.module.scss'
import { BoldButton } from 'components/shared/BoldButton/BoldButton'
import { t } from 'ttag'
import BackIcon from 'assets/icons/back-arrow.svg'
import NextIcon from 'assets/icons/next-arrow-white.svg'
import cx from 'classnames'

type QuestionContainerProps = {
  questionIndex?: number
  totalQuestions?: number
  finished?: boolean
  previousPage?: React.MouseEventHandler<HTMLDivElement>
  answered?: boolean
  finishTest?: React.MouseEventHandler<HTMLDivElement>
  nextUnanswered?: React.MouseEventHandler<HTMLDivElement>
  nextPage?: React.MouseEventHandler<HTMLDivElement>
  collapse?: boolean
  children?: React.ReactNode
}

export const QuestionContainer = ({
  questionIndex,
  totalQuestions,
  finished,
  previousPage,
  answered,
  finishTest,
  nextUnanswered,
  nextPage,
  collapse,
  children,
}: QuestionContainerProps) => {
  return (
    <div
      className={cx(styles.questionContainer, {
        [styles.collapse]: !!collapse,
      })}
    >
      <div className={styles.content}>
        <div className={styles.label}>{t`Statement`}</div>
        <div className={styles.counter}>
          <span className={styles.bold}>{questionIndex}</span>/
          <span>{totalQuestions}</span>
        </div>
        {children}
      </div>
      <div className={styles.buttons}>
        {finished ? null : (
          <BoldButton
            label={t`Previous`}
            onClick={previousPage}
            icon={BackIcon}
            isIconFirst
            isPrimary={false}
            width={'10rem'}
          />
        )}
        <BoldButton
          label={finished ? t`Finish` : t`Next`}
          onClick={
            answered ? (finished ? finishTest : nextUnanswered) : nextPage
          }
          icon={NextIcon}
          width={'10rem'}
        />
      </div>
    </div>
  )
}
